import { useFormContext } from 'react-hook-form';

import { systemProductCategorySlug } from '../../../../../constants/systemProductCategorySlug';
import GenericSwitchboardSettingsProductSelect from './GenericSwitchboardSettingsProductSelect';

export default function ReservedBlindPlate({ isDisabled, isRequired = false }) {
  const { watch } = useFormContext();

  const verticalModules = watch('verticalModulesPerReservedRow');
  const horizontalModules = watch('horizontalModulesPerRow');

  const params = {
    verticalModules,
    horizontalModules,
    categorySlug: systemProductCategorySlug.BlindPlate
  };

  return (
    <GenericSwitchboardSettingsProductSelect
      isDisabled={isDisabled}
      isRequired={isRequired}
      displayName="Reserved Blind Plate"
      inputName="reservedBlindPlate"
      params={params}
    />
  );
}
